import { useEffect } from 'react';
import PropTypes from 'prop-types';
import CodeEditorHeader from '../CodeEditorHeader/CodeEditorHeader';
import { getResultBlockHeight } from '../codeEditor.helper';
// eslint-disable-next-line import/no-named-as-default
import getJsCodeForEvaluation from '../jsIframeCodeGenerator';
import './CodeResult.scss';

const JSCodeResult = ({
	code,
	isHorizontalView,
	editorsNumber,
	hideIframe,
	field,
	name,
	isCodeExample,
	// isJsOnlyCodeExample,
}) => {
	// const iframeId = `cwt_res_iframe_${name}`;
	const iframeTestsId = `cwt_res_tests_iframe_${name}`;
	// const iframeWrapperId = `cwt_result_${name}`;
	const iframeWrapperTestsId = `cwt_result_tests_${name}`;
	useEffect(() => {
		// Regular render
		// if (!isJsOnlyCodeExample) {
		// 	document.getElementById(
		// 		iframeWrapperId,
		// 	).innerHTML = `<iframe id="${iframeId}" height="${getResultBlockHeight({
		// 		isHorizontalView,
		// 		editorsNumber,
		// 	})}"></iframe>`;
		// 	const codeString = code ? `<script>${code}</script>` : '';
		// 	document.querySelector(`#${iframeId}`).contentDocument.write(codeString);
		// }

		if (code) {
			// Render for tests
			document.getElementById(
				iframeWrapperTestsId,
			).innerHTML = `<iframe id="${iframeTestsId}" height="${getResultBlockHeight({
				isHorizontalView,
				editorsNumber,
			})}"></iframe>`;
			const jsTests = field?.options?.jsTests || null;
			const codeStringWithTests = getJsCodeForEvaluation({
				code,
				tests: jsTests,
				name,
			});
			const codeStringWithTestsScript = codeStringWithTests
				? `<script>${codeStringWithTests}</script>`
				: '';
			document
				.querySelector(`#${iframeTestsId}`)
				.contentDocument.write(codeStringWithTestsScript);
		}
	}, [code]);

	return (
		<div className="CodeResult">
			{!isCodeExample && <CodeEditorHeader name="Result" theme="dark" />}
			{/* <div
				id={iframeWrapperId}
				style={{ display: hideIframe ? 'none' : 'block' }}
			/> */}
			<div
				id={iframeWrapperTestsId}
				style={{ display: hideIframe ? 'none' : 'block' }}
			/>
		</div>
	);
};

JSCodeResult.propTypes = {
	code: PropTypes.string,
	isHorizontalView: PropTypes.bool,
	editorsNumber: PropTypes.number,
	hideIframe: PropTypes.bool,
	isCodeExample: PropTypes.bool,
	// isJsOnlyCodeExample: PropTypes.bool,
	name: PropTypes.string,
	field: PropTypes.shape({
		value: PropTypes.string,
		// eslint-disable-next-line react/forbid-prop-types
		options: PropTypes.any,
	}),
};

export default JSCodeResult;
